import { render, staticRenderFns } from "./DetailsView.vue?vue&type=template&id=26a3c9b2&scoped=true&lang=pug"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"
import style0 from "./DetailsView.vue?vue&type=style&index=0&id=26a3c9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a3c9b2",
  null
  
)

export default component.exports